import SupportAssistant from 'components/SupportAssistant/SupportAssistant';
import React, { useMemo } from 'react';
import { Outlet, useLocation, Navigate, matchRoutes } from 'react-router-dom';
import { useAuthContext } from 'context/auth.context';
import { privateRoutes, RouteInterface } from './routes';
import Loading from '../components/Messages/Loading/Loading';
import NotAuthorized from 'pages/NotAuthorized';

function PrivateRoute() {
  const { loading, isSessionActive, hasPermission } = useAuthContext();
  const location = useLocation();
  // Cast privateRoutes to match React Router's expected type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const matchedRoute = matchRoutes(privateRoutes as any, location);

  const permissible = useMemo(() => {
    if (!matchedRoute) {
      return <Outlet />;
    }

    // Cast to RouteInterface to access custom properties
    const route = matchedRoute[0].route as RouteInterface;

    if (route.isAdmin && !hasPermission('access', 'Admin')) {
      return false;
    }

    const permission = route.permission;
    return (
      !permission || hasPermission(permission.action, permission.subject, permission?.conditions)
    );
  }, [location.pathname, hasPermission, matchedRoute]);

  if (loading) {
    return <Loading />;
  } else if (!isSessionActive()) {
    return <Navigate to={'/login'} />;
  } else if (!permissible) {
    return <NotAuthorized />;
  }

  return (
    <>
      <Outlet />
      <SupportAssistant />
    </>
  );
}

export default PrivateRoute;
